
import { z } from "zod";

export const FinanciallyResponsiblePartyValues = ["HOMEOWNER", "PARTNER"] as const;
export const FinanciallyResponsiblePartySchema = /* @__PURE__ */ z.enum(FinanciallyResponsiblePartyValues);
export const FinanciallyResponsibleParty: (typeof FinanciallyResponsiblePartySchema)["enum"] = { "HOMEOWNER": "HOMEOWNER", "PARTNER": "PARTNER" };
export type FinanciallyResponsibleParty = (typeof FinanciallyResponsiblePartyValues)[number];
export const FinanciallyResponsiblePartyDisplayNames = { "HOMEOWNER": "Homeowner",
"PARTNER": "Partner", } satisfies Record<FinanciallyResponsibleParty, string>;
